import React from 'react';
import { BottomNavigation, Box, IconButton, Grid, Link } from '@mui/material';
import { colorNowWhite } from '../../asset/index';
import { CONSTANTS } from '../../utils/constant';
export const BottomNavBar = () => {
  return (
    <BottomNavigation
      sx={{ backgroundColor: '#C7C9C7', marginTop: '5%', height: '235px' }}
    >
      <Grid
        container
        direction="row"
        spacing={2}
        sx={{ marginLeft: '30px', marginRight: '30px', marginTop: '30px' }}
      >
        <IconButton
          disableRipple
          size="large"
          edge="start"
          color="inherit"
          flex="1"
        >
          <img alt="instaColr logo" src={colorNowWhite} />
        </IconButton>

        <Grid
          container
          justifyContent="center"
          alignItems="center"
          sx={{ color: '#303C43' }}
          className="line-height-20 font-16 font-weight-400"
        >
          <Grid item xs={6}>
            <Box>
              {' '}
              For support, contact ColorNow team
              {/* <a
                className="cursor-pointer"
                style={{ color: '#385DAE', textDecoration: 'none' }}
                href="mailto:colorpredictiontool@avient.com"
              >
                {' '}
                {CONSTANTS.supportEmail}
              </a> */}
            </Box>
            {/* <Box className='cursor-pointer'><Link href="/policy" color="inherit" underline="hover"> Privacy Policy </Link></Box>
            <Box className='cursor-pointer'><Link href="/conditions" color="inherit" underline="hover"> Terms  & Conditions</Link></Box> */}
          </Grid>
          <Grid item xs={6}>
            <Box sx={{ float: 'right' }}>
              © 2024 ColorNow<sup>TM</sup>
            </Box>
          </Grid>
        </Grid>
      </Grid>
    </BottomNavigation>
  );
};
